import EventCreateFormBasicInfoLocation from 'pages/events/events-create-event-form/event-create-form-basic-info/event-create-form-basic-info-location/eventCreateFormBasicInfoLocation';

export default EventCreateFormBasicInfoLocation;
